window.addEventListener('DOMContentLoaded',function () {
    var elements  = document.querySelectorAll(".manuly-header-submenu");
    for (const element of elements) {
        var parWidt = element.parentElement.offsetWidth / 2;
        var widt = element.offsetWidth / 2;
        element.style.left = (parWidt) - (widt) + "px"
    }
});